import { render, staticRenderFns } from "./ElementsBlockPreview.vue?vue&type=template&id=40193cac&"
import script from "./ElementsBlockPreview.vue?vue&type=script&lang=js&"
export * from "./ElementsBlockPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports